<template>
  <div class="content-block">
    <ResourceTypeForm @done="onDone"></ResourceTypeForm>
  </div>
</template>

<script>
import ResourceTypeForm from 'CORE/components/resource/type/form'

export default {
    name: 'ResourceTypeNewView',
    components: {
        ResourceTypeForm,
    },
    methods: {
        onDone() {
            this.$router.push({ name: 'resourceTypesList' })
        },
    },
}
</script>
